export const PHONE_MASK = ['+', '1', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const TIME_MASK = [/\d/, /\d/, ':', /\d/, /\d/, ' ', /[APap]/, /[Mm]/];
export const DATE_MASK = ['+', '1', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
